














import { Vue, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MyMixin from '@/mixins/mixins';
import Banner from '@/components/Banner.vue';
import { BottomTabbar } from '@/components';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { getBaseinfo } from '@/api/api';
import axios from 'axios';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
  mixins: [MyMixin],
})
export default class Home extends Vue {
  option = config.OPTHINES;
  bannerSrc = '';

  async created() {
    const res = await getBaseinfo(this.option.voteName);
    this.bannerSrc = res.data.banner;
    // 分享
    this.$appShareInfo({
      title: '上游新闻有奖问答',
      url: window.location.href,
      subtitle: '提问题，到上游。欢迎参加有奖提问',
      classId: -1,
      id: -1,
      image: (this.bannerSrc as any).banner,
      type: 3,
    });
    this.$wxShareInfo({
      title: '上游新闻有奖问答',
      subtitle: '提问题，到上游。欢迎参加有奖提问',
      image: (this.bannerSrc as any).banner,
    });
    this.$addPv(371);
    // 稿子pv
    if (process.env.NODE_ENV === 'production') {
      axios.get(
        `//activity.cqcb.com/e/public/ViewClick/?classid=3049&id=1950495&addclick=1`,
      );
    }
  }
}
